module.exports = __webpack_public_path__ + "images/psp/ATV/10x10.svg";